import { render, staticRenderFns } from "./OrdersDetailResale.vue?vue&type=template&id=5d6cf988&scoped=true"
import script from "./OrdersDetailResale.vue?vue&type=script&lang=js"
export * from "./OrdersDetailResale.vue?vue&type=script&lang=js"
import style0 from "./OrdersDetailResale.vue?vue&type=style&index=0&id=5d6cf988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6cf988",
  null
  
)

export default component.exports